var lib_core = require("lib-core");
var ui_templates = require("ui-templates");
var THREE = require("three");
var Model3dViewer = require('../../../shared/extensions/3dModelViewer/3dModelViewer.js');

var ModelAdderView = function(model, stateMachine, editorHolder) {
    var self = this;

    this.model = model;
    this.stateMachine = stateMachine;
    this.editorHolder = editorHolder;

    this.makePublicModal = null;
    // 
    // this.model.model3d3JSObject.onChange(this, function(value){
    //     if(value) {
    //         self.preview3JSObject();
    //     }
    // }, 10);

    
    this.model.makeModelPublicModalShown.onChange(this, function(value){
        if(value) {
            self.showMakeModelPublicModal();
        } else {
            if(self.makePublicModal){
                self.makePublicModal.remove();
                self.makePublicModal = null;
            }
        }
    }, 10);
};

module.exports = ModelAdderView;

ModelAdderView.prototype.showMakeModelPublicModal = function() {
    var self = this;

    if(this.makePublicModal){
        this.makePublicModal.remove();
        this.makePublicModal = null;
    }

    this.makePublicModal = new ui_templates.Modal({
        target: $("body"),
        fields: {
            'title': "Make 3D Model Public",
            'body': "<b>Your 3D Model will be publicly shared.</b><br><br> 3D Models uploaded to publicly shared packages are also be make public.",
            'modal': true
        }
    });

    this.makePublicModal.setTheme("dark");
   
    var yes = this.makePublicModal.addButton("OK");
    yes.$el.on('Cioui:Modal:ModalButton:clicked', function(){
        var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.MAKE_MODEL_PUBLIC_AND_ADD);
        self.stateMachine.handle(cEvent);
    });

    var no = this.makePublicModal.addButton("CANCEL", "dark");
    no.$el.on('Cioui:Modal:ModalButton:clicked', function(){
        var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.CANCEL_ADD_MODEL);
        self.stateMachine.handle(cEvent);
    });

    this.makePublicModal.$el.on('Cioui:Modal:close:clicked', function(){
        var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.CANCEL_ADD_MODEL);
        self.stateMachine.handle(cEvent);
    });
};


//TODO:draggable window/resizable
// ModelAdderView.prototype.preview3JSObject = function() {
//     var self = this;

//     //show popup
//     this.previewModal = new ui_templates.Modal({
//         target: $("body"),
//         fields: {
//             'title': "Preview - " + self.model.model3dAsset["name"],
//             'body': `<div class='3dmodel__preview' style="height:400px;"></div>`,
//             'modal': true
//         }
//     });

//     var model3dViewer = new Model3dViewer($('.3dmodel__preview'));

//     //popup close
//     this.previewModal.$el.on('Cioui:Modal:close:clicked', function(){
//         self.previewModal.remove();

//         //cleanup
//         model3dViewer.clean();
//     });

//     var addBtn = this.previewModal.addButton("Add", "regular");
//     addBtn.$el.on('Cioui:Modal:ModalButton:clicked', function(){
//         var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.TRAY_MODEL_SELECTED)
//                     .data("model_id", self.model.model3dAsset["id"]);
//         self.stateMachine.handle(cEvent);

//         //cleanup
//         model3dViewer.clean();

//         self.previewModal.remove();
//     });

//     //render 3d model
//     model3dViewer.render3JSObject(self.model.model3d3JSObject());
// };